import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { getUserById, updateUser } from '../../../../api/user'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'

function providerLabel(authProvider) {
  if (authProvider === 'both') return 'Comarca + PID'
  if (authProvider === 'pid') return 'PID OAuth'
  return 'Comarca (local)'
}

export default function EditUserPage() {
  const [userData, setUserData] = useState(null)
  const [newPassword, setNewPassword] = useState('')
  const userId = useParams().id
  const history = useHistory()
  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    if (!userId) {
      history.push('/users')
      return
    }
    getUserById(userId)
      .then((res) => {
        if (res.status === 200) {
          const u = res.data
          delete u.password
          setUserData(u)
          disableLoadingData()
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudo cargar el usuario.' })
        history.push('/users')
      })
  }, [userId, disableLoadingData, history])

  function save() {
    const payload = {
      fullName: userData.fullName,
      email: userData.email,
      role: userData.role,
      active: userData.active,
      segment: userData.segment || 'turista',
    }
    if (newPassword.trim()) {
      payload.password = newPassword.trim()
    }
    updateUser(userId, payload)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({ title: 'Guardado', customMessage: 'Usuario actualizado.' })
          history.push('/users')
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron guardar los cambios.' })
      })
  }

  if (isLoadingData || !userData) return <ContentSkeleton />

  return (
    <>
      <Card>
        <CardHeader title="Editar usuario" />
        <CardBody>
          <TextField
            label="Nombre"
            value={userData.fullName || ''}
            onChange={(e) => setUserData({ ...userData, fullName: e.target.value })}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            label="Email"
            value={userData.email || ''}
            onChange={(e) => setUserData({ ...userData, email: e.target.value })}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <p>
            <strong>Origen:</strong> {providerLabel(userData.authProvider)}
            {userData.pidSub ? ` · pidSub: ${userData.pidSub}` : ''}
          </p>
          <TextField
            label="Nueva contraseña comarca (opcional)"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            margin="normal"
            variant="outlined"
            fullWidth
            helperText="Si se informa, habilita o actualiza el login de comarca (email + password)."
          />
          <FormControl variant="outlined" margin="normal" fullWidth>
            <InputLabel>Rol</InputLabel>
            <Select
              value={userData.role || 'client'}
              onChange={(e) => setUserData({ ...userData, role: e.target.value })}
              label="Rol"
            >
              <MenuItem value="admin">Admin</MenuItem>
              <MenuItem value="client">Client</MenuItem>
            </Select>
          </FormControl>
          <FormControl variant="outlined" margin="normal" fullWidth>
            <InputLabel>Segmento push</InputLabel>
            <Select
              value={userData.segment || 'turista'}
              onChange={(e) => setUserData({ ...userData, segment: e.target.value })}
              label="Segmento push"
            >
              <MenuItem value="turista">Turista</MenuItem>
              <MenuItem value="residente">Ciudadano</MenuItem>
            </Select>
          </FormControl>
          <FormControlLabel
            control={
              <Checkbox
                checked={userData.active !== false}
                onChange={() => setUserData({ ...userData, active: !(userData.active !== false) })}
              />
            }
            label="Activo"
          />
        </CardBody>
      </Card>
      <Button onClick={() => history.push('/users')} variant="outlined" style={{ marginRight: 20 }}>
        Volver
      </Button>
      <Button onClick={save} variant="outlined" color="primary">
        Guardar
      </Button>
    </>
  )
}
